import { theme } from '../../styles/theme';

export const TestsTableContainer = {
  background: theme.palette.common.white,
  borderBottom: 0
};

export const TestsTableTHead = {
  background: theme.palette.common.lightGrey5,
  fontWeight: 600,
  border: 0,
  [theme.breakpoints.down('tablet')]: {
    display: 'none'
  }
};

export const TestsTableTHeadTableRow = {
  '> th: last-child': {
    textAlign: 'center'
  }
};

export const dynamicColumnsStyle = (el: string) => {
  const skills = ['Speaking', 'Listening', 'Reading', 'Writing'];
  return {
    border: 0,
    fontWeight: 600,
    '@media screen and (max-width: 1199px)': {
      display: skills.includes(el) ? 'none !important' : 'table-cell'
    },
    minWidth: el === 'Tests' ? '180px' : 'auto'
  };
};

export const TitleAndDate = {
  display: 'flex',
  flexFlow: 'column',
  fontSize: '14px',
  fontWeight: 400
};

export const TestsTableTBody = {
  td: {
    height: '69px'
  }
};

export const HideLastRowBorder = {
  '&:last-of-type': {
    td: {
      border: 0
    }
  }
};

/** Main data row when a details row follows — avoids a double line between the pair */
export const HideRowBottomBorder = {
  td: {
    borderBottom: 0
  }
};

export const getLicenseTableRowSx = (
  multipleLicenses: boolean,
  hasFollowingDetailsRow: boolean,
  clickableRow: boolean
) => [
  multipleLicenses ? HideLastRowBorder : {},
  hasFollowingDetailsRow ? HideRowBottomBorder : {},
  {
    cursor: clickableRow ? 'pointer' : ('default' as const)
  }
];

export const TestsTableTestCell = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 600,
  img: {
    marginRight: '16px'
  }
};

export const TestsTableOverallCell = {
  fontSize: '16px',
  fontWeight: 600,
  width: '200px',
  textAlign: 'left'
};

export const TestsTableArrowCellImage = {
  height: '15px'
};

export const NoTestsDescription = {
  fontSize: '14px',
  paddingBottom: '30px',
  fontWeight: '600',
  color: theme.palette.common.darkBlue2,
  [theme.breakpoints.down('tablet')]: {
    width: '248px',
    paddingBottom: 0
  }
};

export const NoTestsContainer = {
  alignItems: 'center'
};

export const InitialPadding = {
  '&:first-of-type': {
    paddingLeft: '30px'
  }
};
